// DTM
import React, { Component } from "react"
import styled from "styled-components"

import scale from "../helper/scaling"
import ArticleAbstract, { FlatBody } from "./ArticleAbstract"

const Wrapper = styled.div`
  width: calc(100% - 50px);
  float: left;
  margin: 0 25px;

  @media (min-width: 1400px) {
    width: 1350px;
    margin: 0 calc(50% - 675px);
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0;
  }
`
const Items = styled.div`
  width: 1040px;
  margin: 36px calc(50% - 520px) 0 calc(50% - 520px);
  float: left;

  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  @media (max-width: 1100px) {
    width: 100%;
    margin: ${scale(1100, 767, 36, 18, "vw")} 0 0 0;
  }
  @media (max-width: 700px) {
    width: calc(100% - 22px);
    margin: 25px 11px 0 11px;
  }
`

class SetTeam extends Component {
  constructor(props) {
    super(props)
    for (let item in props.set) {
      if (
        props.set[item] &&
        props.set[item].images &&
        (props.set[item].images.intro || props.set[item].images.main)
      ) {
        this.state = {
          index: item
        }
        break
      }
    }
  }

  clickHandler = index => () => {
    this.setState({ index })
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <Wrapper>
        <Header content={this.props.set[this.state.index]} />
        <Items>
          {this.props.set.map((item, index) => (
            <SetTeamItem
              key={index}
              content={item}
              clickHandler={this.clickHandler(index)}
            />
          ))}
        </Items>
      </Wrapper>
    )
  }
}

export default SetTeam

const HeaderWrapper = styled.div`
  height: 547px;
  width: 100%;
  background-color: #000000;
  position: relative;
  overflow: hidden;

  @media (max-width: 1170px) {
    height: ${scale(1170, 767, 547, 330, "vw")};
  }
  @media (max-width: 700px) {
    height: auto;
    width: calc(100% - 46px);
    padding: 83.1vw 23px 45px 23px;
  }
`
const HeaderImage = styled.div`
  width: 796px;
  height: 530px;

  position: absolute;
  top: 0;
  left: calc(50% - 236px);

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 1170px) {
    left: auto;
    right: 0;

    width: ${scale(1170, 767, 796, 449, "vw")};
    height: ${scale(1170, 767, 530, 299, "vw")};
  }
  @media (max-width: 700px) {
    height: 83.1vw;
    width: 100%;
  }
`
const HeaderImageOverlay = styled.div`
  width: 796px;
  height: 530px;

  position: absolute;
  top: 0;
  left: calc(50% - 236px);

  background-image: radial-gradient(
    ellipse at 50% 33%,
    transparent,
    rgba(0, 0, 0, 0.08) 57.14%,
    #000000 72.27%
  );
  background: radial-gradient(
    ellipse at 50% 33%,
    transparent,
    rgba(0, 0, 0, 0.08) 57.14%,
    #000000 72.27%
  );

  @media (max-width: 1170px) {
    left: auto;
    right: 0;

    width: ${scale(1170, 767, 796, 449, "vw")};
    height: ${scale(1170, 767, 530, 299, "vw")};
  }
  @media (max-width: 700px) {
    height: 83.1vw;
    width: 100%;
  }
`
const HeaderText = styled.div`
  height: calc(100% - 22px);
  width: 410px;
  position: absolute;
  left: calc(50% - 520px);
  top: 22px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1170px) {
    left: 40px;
    height: 100%;
    top: 0;
    width: ${scale(1170, 767, 410, 300, "vw")};
  }
  @media (max-width: 700px) {
    position: relative;
    top: 0;
    left: 0;
    float: left;
    width: 100%;
  }
`
const HeaderTitle = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 33px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.76;
  letter-spacing: 0.5px;
  color: #ffffff;

  @media (max-width: 1170px) {
    font-size: ${scale(1170, 767, 33, 26, "vw")};
    line-height: ${scale(1170, 767, 33 * 1.76, 26 * 1, "vw")};
    margin-bottom: ${scale(1170, 767, 0, 6, "vw")};
    letter-spacing: 0.4px;
  }
  @media (max-width: 700px) {
    font-size: 21px;
    letter-spacing: 0.3px;
    margin: 31px 0 19px 0;
  }
`
const HeaderBody = styled.div`
  width: 100%;

  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: 1px;
  color: #ffffff;

  h1,
  h2,
  h3 {
    height: 27px;
    font-size: 22px;
    font-weight: bold;
    line-height: 27px;
    letter-spacing: 0.3px;
    margin: 0 0 25px 0;
  }

  @media (max-width: 1170px) {
    font-size: ${scale(1170, 767, 14, 12, "vw")};
    line-height: ${scale(1170, 767, 14 * 1.71, 12 * 1.5, "vw")};
    letter-spacing: ${scale(1170, 767, 1, 0.2, "vw")};

    h1,
    h2,
    h3 {
      font-size: ${scale(1170, 767, 22, 16, "vw")};
      letter-spacing: 0.2px;

      margin: 0 0 ${scale(1170, 767, 25, 8, "vw")} 0;
    }
  }

  @media (max-width: 700px) {
    font-size: 11px;
    line-height: 1.64;
    letter-spacing: 0.2px;

    h1,
    h2,
    h3 {
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.2px;

      margin-bottom: 5px;
    }
  }
`

class Header extends ArticleAbstract {
  render() {
    return (
      <HeaderWrapper>
        <HeaderImage style={this.image(true)} />
        <HeaderImageOverlay />
        <HeaderText>
          <HeaderTitle>{this.title()}</HeaderTitle>
          <HeaderBody>
            <FlatBody>{this.body()}</FlatBody>
          </HeaderBody>
        </HeaderText>
      </HeaderWrapper>
    )
  }
}

class SetTeamItem extends ArticleAbstract {
  render() {
    let content = this.props.content
    if (this.imageUrl())
      return <Member content={content} clickHandler={this.props.clickHandler} />
    return <Team content={content} />
  }
}

const TeamTitle = styled.div`
  width: 100%;
  margin: 44px 0 14px 0;

  font-family: Lato;
  font-size: 35px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.66;
  letter-spacing: 0.5px;
  color: #3949ab;

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 35, 27, "vw")};
    line-height: ${scale(1100, 767, 35 * 1.66, 27 * 2.15, "vw")};
    letter-spacing: 0.4px;

    margin: ${scale(1100, 767, 44, 32, "vw")} 0
      ${scale(1100, 767, 14, 12, "vw")} 0;
  }
  @media (max-width: 700px) {
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.3px;

    width: calc(100% - 24px);
    margin: 18px 12px 11px 12px;
  }
`

class Team extends ArticleAbstract {
  render() {
    return <TeamTitle>{this.title()}</TeamTitle>
  }
}

const MemberWrapper = styled.div`
  width: 346px;
  margin: 36px 0;

  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;

  cursor: pointer;

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 344, 232, "vw")};
    margin: ${scale(1100, 767, 36, 18, "vw")} 0;
  }
  @media (max-width: 700px) {
    width: calc(50% - 24px);
    margin: 10px 12px;
  }
`
const MemberImage = styled.div`
  width: 276px;
  height: 276px;
  border: 0px solid #ffffff;
  border-radius: 139px;
  margin-bottom: 60px;

  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 276, 200, "vw")};
    height: ${scale(1100, 767, 276, 200, "vw")};
    margin-bottom: ${scale(1100, 767, 60, 28, "vw")};
  }
  @media (max-width: 700px) {
    width: calc(50vw - 35px);
    height: calc(50vw - 35px);

    margin-bottom: 10px;
  }
`
const MemberTitle = styled.div`
  width: calc(100% - 30px);
  margin: 0 15px;

  font-family: Lato;
  font-size: 22px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 27px;
  letter-spacing: 0.3px;
  text-align: center;
  color: #000000;

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 22, 16, "vw")};
    line-height: ${scale(1100, 767, 27, 19, "vw")};
    letter-spacing: 0.2px;
    margin-bottom: ${scale(1100, 767, 0, 6, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 11px;
    line-height: 13px;
    margin: 0 0 3px 0;
    width: 100%;
  }
`
const MemberBody = styled.div`
  width: calc(100% - 30px);
  margin: 0 15px;
  min-height: 19px;

  p {
    display: none;
    font-size: 0px;
    height: 0;
    width: 0;
    overflow: hidden;
    margin: 0;
  }
  h1,
  h2,
  h3 {
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 19px;
    letter-spacing: 0.2px;
    text-align: center;
    color: #000000;
    margin: 0;
  }
  @media (max-width: 1100px) {
    h1,
    h2,
    h3 {
      font-size: ${scale(1100, 767, 16, 12, "vw")};
      line-height: ${scale(1100, 767, 19, 15, "vw")};
    }
  }
  @media (max-width: 700px) {
    h1,
    h2,
    h3 {
      font-size: 10px;
      line-height: 1.4;
      letter-spacing: 0.1px;

      margin: 0;
      width: 100%;
    }
  }
`

class Member extends ArticleAbstract {
  render() {
    return (
      <MemberWrapper onClick={this.props.clickHandler}>
        <MemberImage style={this.image()} />
        <MemberTitle>{this.title()}</MemberTitle>
        <MemberBody>{this.body()}</MemberBody>
      </MemberWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SetTeam.js